export function customer(state) {
  return state.customer;
}
